import { render } from "./DialogFontList.vue?vue&type=template&id=0ea9ce10&scoped=true"
import script from "./DialogFontList.vue?vue&type=script&lang=js"
export * from "./DialogFontList.vue?vue&type=script&lang=js"

import "./DialogFontList.vue?vue&type=style&index=0&id=0ea9ce10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea9ce10"]])

export default __exports__